import React from 'react';
import { IconButton } from '../../components/Button';
import Caret from '../../components/Caret';
import Tooltip from '../../components/Tooltip';
import * as styles from './CategoryHeadingButton.module.scss';

interface CategoryHeadingProps {
  selectedEntityCategory?: string | null;
  onHeaderClick: () => void;
}

const CategoryHeadingButton = ({
  selectedEntityCategory,
  onHeaderClick,
}: CategoryHeadingProps) => {
  const tooltip = selectedEntityCategory ? 'Go back' : 'Show all';

  return (
    <Tooltip content={tooltip} placement="bottom" asChild>
      <IconButton
        className={styles.icon}
        onClick={() => onHeaderClick()}
        aria-label={tooltip}
      >
        <Caret
          direction={selectedEntityCategory ? 'left' : 'right'}
          size={12}
          block
        />
      </IconButton>
    </Tooltip>
  );
};

export default CategoryHeadingButton;
